import React, { useState } from "react";
import { QrCode, ChevronRight } from "lucide-react";
import StoreStickerOverlay from "./StoreStickerOverlay";
import "./StoreStickerRow.css";

/**
 * StoreStickerRow
 *
 * Settings-page row that opens the store sticker overlay
 * (view / download / share) when clicked.
 *
 * Props:
 *  - storeName   {string}
 *  - address     {string}
 *  - category    {string}
 *  - phoneNumber {string}
 *  - storeUrl    {string}
 */
export default function StoreStickerRow({ storeName, address, category, phoneNumber, storeUrl }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className='ssr-row'>
        <div className='ssr-icon'>
          <QrCode size={18} strokeWidth={2} />
        </div>
        <div className='ssr-text'>
          <span className='ssr-title'>Store Sticker</span>
          <span className='ssr-subtitle'>QR sticker for your storefront and packaging</span>
        </div>
        <button type='button' className='ssr-btn' onClick={() => setIsOpen(true)}>
          View Sticker
          <ChevronRight size={15} strokeWidth={2} />
        </button>
      </div>

      {isOpen && (
        <StoreStickerOverlay
          storeName={storeName}
          address={address}
          category={category}
          phoneNumber={phoneNumber}
          storeUrl={storeUrl}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
